import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IonApp } from '@ionic/angular/standalone';

/**
 * 操作面の幅上限はここだけ（〜896px）。
 * MainLayout 内外・auth も同じ列に乗る。モーダルは ion-app 直下に出るため別扱い。
 * サイド色は ionic-theme.scss（ion-app / .app-shell）。
 */
@Component({
  imports: [IonApp, RouterOutlet],
  selector: 'app-root',
  template: `
    <ion-app>
      <div
        class="app-shell mx-auto flex h-full min-h-0 w-full max-w-4xl flex-col"
      >
        <router-outlet />
      </div>
    </ion-app>
  `,
})
export class App {}
